import befolkningsstatistikk from './befolkningsstatistikk.json';

export const getPopulationForMunicipalityCode = ({ municipalityCode }) => {
    const paddedMunicipalityCode = municipalityCode?.padStart(4, '0');
    const index = befolkningsstatistikk.dataset.dimension.Region.category.index[`${paddedMunicipalityCode}`];
    return befolkningsstatistikk.dataset.value[index];
};
